<ng-container *ngIf="formRef?.control as formRefControl">
  <form [formGroup]="formRefControl" class="sourceSiteInfoForm cmn-forms">
    <mat-tab-group
      *ngIf="sites && sites.length"
      animationDuration="0ms"
      (selectedTabChange)="tabChanged($event)"
      [selectedIndex]="tabIndex"
    >
      <mat-tab formArrayName="sites" *ngFor="let page of $any(sites).controls; let pageIndex = index">
        <ng-template mat-tab-label class="tab-label">
          {{ page.get('name').value || 'New Source Site' }}
        </ng-template>
        <div class="formContainer " [formGroupName]="pageIndex">
          <div class="formContainer__formSection ">
            <div class="formSection__row ">
              <div class="formSection__input width--47">
                <h2 class="input__title">Source Site Name <span class="requiredIndicator">*</span></h2>
                <mat-form-field floatLabel="never">
                  <input placeholder="Site Name" matInput type="text" formControlName="name" />
                  <mat-error>{{ page.controls.name?.errors | formError }}</mat-error>
                  <mat-icon *ngIf="!page.controls.name?.errors" class="validCheck">check</mat-icon>
                </mat-form-field>
              </div>
            </div>
            <div class="formSection__row ">
              <div class="formSection__input row--fullWidthInput">
                <widget-geo-code-address-autocomplete
                  [isRequired]="true"
                  (outputAddressDetailsEvent)="outputAddressDetailsEvent($event)"
                  [addressSearchFormControl]="address.get('line1')"
                >
                </widget-geo-code-address-autocomplete>
              </div>
            </div>
            <div class="formSection__row row--twoInputs">
              <div class="formSection__input" [formGroup]="address">
                <h2 class="input__title">Province<span class="requiredIndicator">*</span></h2>
                <mat-form-field floatLabel="never">
                  <mat-select [required]="true" formControlName="provinceUniqueId">
                    <mat-option>Select State/Province</mat-option>
                    <mat-option [value]="province.uniqueId" *ngFor="let province of countryStoreService.provinces">
                      {{ province.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{ address.controls.provinceUniqueId?.errors | formError }}</mat-error>
                  <mat-icon *ngIf="!address.controls.provinceUniqueId?.errors" class="validCheck">check</mat-icon>
                </mat-form-field>
              </div>
              <div class="formSection__input">
                <h2 class="input__title">Municipality</h2>
                <mat-form-field floatLabel="never">
                  <input placeholder="" matInput type="text" formControlName="municipalityName" />
                  <mat-error>{{ page.controls.municipalityName?.errors | formError }}</mat-error>
                  <!-- <mat-icon *ngIf="!page.controls.municipalityName?.errors" class="validCheck">check</mat-icon> -->
                </mat-form-field>
              </div>
            </div>
            <div class="formSection__row">
              <div class="formSection__input" [formGroup]="address">
                <h2 class="input__title">Postal Code <span class="requiredIndicator">*</span></h2>
                <mat-form-field floatLabel="never">
                  <input placeholder="Postal Code" matInput type="text" formControlName="postalCode" />
                  <mat-error>{{ address.controls.postalCode?.errors | formError }}</mat-error>
                  <mat-icon *ngIf="!address.controls.postalCode?.errors" class="validCheck">check</mat-icon>
                </mat-form-field>
              </div>
            </div>
            <div class="formSection__row">
              <div class="formSection__input width--47" [formGroup]="address">
                <h2 class="input__title">City<span class="requiredIndicator">*</span></h2>
                <mat-form-field floatLabel="never">
                  <input placeholder="" matInput type="text" formControlName="city" />
                  <mat-error>{{ address.controls.city?.errors | formError }}</mat-error>
                  <mat-icon *ngIf="!address.controls.city?.errors" class="validCheck">check</mat-icon>
                </mat-form-field>
              </div>
            </div>

            <div class="" formGroupName="contact">
              <h1 class="formSection__header">Contact Information</h1>
              <div class="formSection__row ">
                <div class="formSection__input width--47">
                  <h2 class="input__title">Full Name <span class="requiredIndicator">*</span></h2>
                  <mat-form-field floatLabel="never">
                    <input placeholder="Full Name" matInput type="text" formControlName="name" />
                    <mat-error>{{ page.controls.contact?.controls.name?.errors | formError }}</mat-error>
                    <mat-icon *ngIf="!page.controls.contact?.controls.name?.errors" class="validCheck">check</mat-icon>
                  </mat-form-field>
                </div>
              </div>
              <div class="formSection__row ">
                <div class="formSection__input width--47">
                  <h2 class="input__title">Email ID<span class="requiredIndicator">*</span></h2>
                  <mat-form-field floatLabel="never">
                    <input placeholder="Email ID" matInput type="text" formControlName="email" />
                    <mat-error>{{ page.controls.contact?.controls.email?.errors | formError }}</mat-error>
                    <mat-icon *ngIf="!page.controls.contact?.controls.email?.errors" class="validCheck">check</mat-icon>
                  </mat-form-field>
                </div>
              </div>
              <div class="row--fullWidthInput formRowFlex">
                <div class="formSection__input input--phone width--47">
                  <h2 class="input__title">Phone<span class="requiredIndicator">*</span></h2>
                  <mat-form-field floatLabel="never">
                    <input placeholder="" matInput type="text" formControlName="phoneNumber" mask="(000) 000 - 0000" />
                    <mat-error>{{ page.controls.contact?.controls.phoneNumber?.errors | formError }}</mat-error>
                    <mat-icon *ngIf="!page.controls.contact?.controls.phoneNumber?.errors" class="validCheck">check</mat-icon>
                  </mat-form-field>
                </div>
                <div class="formSection__input extension width--20">
                  <h2 class="input__title">Extension</h2>
                  <mat-form-field floatLabel="never">
                    <input placeholder="" matInput type="text" formControlName="extension" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="formSection__row  ">
              <div class="formSection__input row--fullWidthInput">
                <section class="file-upload doc-upload cmn-grn-box text-center mb-10" *ngIf="page.controls.documents as documentsCtrl">
                  <h3 class="cmn-title-text mb-30">Attach Documents</h3>
                  <div>
                    <site-file-upload
                      [type]="SiteType.SOURCE_SITE"
                      [siteUniqueId]="page.controls.uniqueId.value"
                      formControlName="documents"
                    ></site-file-upload>
                    <mat-error *ngIf="documentsCtrl.dirty && documentsCtrl.errors | formError as formError">
                      {{ formError }}
                    </mat-error>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab [disabled]="true">
        <ng-template mat-tab-label>
          <button mat-icon-button (click)="addTab()">
            <mat-icon>add</mat-icon>
          </button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </form>
</ng-container>
